import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import facultyData from "../UG/facultyData/basicScienceFacultyData";

export const programme = {
  id: "chemistry",
  name: "Chemistry Research Centre",
  short: "Chemistry Research Centre",
  programmeType: "research",
  programmeLabel: "Research Centre",
  duration: "Ph.D. / M.Sc. (Engg.) by Research",
  established: "As per VTU recognition",
  hodId: "f-g-s-kurdekar",
  facultyData,
  facultyDeptId: "bsh",
  hideFacultySection: true,
  hideSharedClubs: true,

  description:
    "The department is recognized as “Research Center” in the year 2010 and offers Ph.D./ M.Sc.(Engg.) program by research, which is affiliated to Visvesvaraya Technological University, Belgaum, vide VTU letter no. VTU/Aca./2010-11/A-9/5960 dated 26-8-2010.The faculty members are actively involved in research activities. Major areas of research are polymer membrane science, nano-materials, synthetic organic chemistry, oleo-chemistry, natural products and bio-fuels & coordination chemistry.Faculty members have published as many as 25 research papers in their respective fields in international journals of high impact factors and have presented a good number of papers in national / international conferences and seminars.",

  image: "/Academics/chemisty.jpg",

  labs: [
    "Chemistry Lab",
    "Organic Synthesis Facilities",
    "Catalysis Workspaces",
    "Research Workspaces",
  ],

  dashboard: [
    ["Recognition", "VTU"],
    ["Research Areas", "05"],
    ["Research Supervisors", "02"],
    ["Research Scholars", "03"],
  ],

  quickFacts: [
    ["Established", "As per VTU recognition"],
    ["Programme", "Ph.D. / M.Sc. (Engg.) by Research"],
    ["Research Supervisors", "02"],
    ["Research Scholars", "03"],
    [
      "Research Areas",
      "Organic Chemistry, Coordination Chemistry, Catalysis, Nanomaterials",
    ],
    ["Affiliation", "VTU, Belagavi"],
  ],

  academicOverview: [
    {
      title: "Research Centre Overview",
      text: "The Chemistry Research Centre provides a platform for research in organic and inorganic chemistry, coordination compounds, catalysis, nanomaterials, and sustainable chemical sciences.",
    },
    {
      title: "Research Facilities",
      text: "The centre supports laboratory-based research through chemistry labs, organic synthesis facilities, catalysis workspaces, research workspaces, and documentation support.",
    },
    {
      title: "Research Culture",
      text: "Faculty members contribute through research publications, doctoral guidance, interdisciplinary work, and scholarly engagement in chemical sciences.",
    },
  ],

  curriculumSupport: [
    "Ph.D. and M.Sc. (Engineering) by Research guidance",
    "Organic synthesis and coordination chemistry research support",
    "Catalysis and nanomaterials experimentation",
    "Molecular docking and synthetic chemistry support",
    "Publication and technical documentation support",
    "Interdisciplinary research mentoring",
  ],

  researchAreas: [
    "Organic Chemistry",
    "Coordination Chemistry",
    "Catalysis",
    "Nanomaterials",
    "Molecular Docking Studies",
  ],

  infrastructureTables: [
    {
      columns: ["Course", "Name of the Laboratory", "Experimental types", "Major Equipment"],
      rows: [[
        "Research and Development (R&D)",
        "Research Lab",
        "Carrying out synthesis of biodiesel and coordination compounds and for Elementary Chemical analysis",
        "Rota Mantle\nUV Chamber\nMelting Point Apparatus\nWater Bath\nSuction Pump\nMagnetic Stirrer\ncum hot plate\nDigital Colorimeter\nRefrigerator\nElectronic Balance",
      ]],
    },
  ],

  achievements: [
    "Supports research publications in chemistry.",
    "Promotes interdisciplinary research activity in chemical sciences.",
    "Supports doctoral research guidance as per VTU norms.",
    "Research focus includes coordination chemistry, catalysis, and organic chemistry.",
  ],

  supervisors: [
    ["Dr. Sneha S kulkarni", "Assistant Professor", "f-sneha-s-kulkarni"],
    ["Dr. Vinod Naik", "Associate Professor", "f-vinod-naik"],
  ],

  researchScholars: [
    ["Ms. Geeta Naik", "Research Scholar", null,"/FacultyCImages/Geeta Naik.png"],
    ["Mr. Bhushan Sail", "Research Scholar", null, "/FacultyCImages/Bhushan Sail.png"],
    ["Ms. Sangeeta Benni", "Research Scholar", null,  "/FacultyCImages/Sangeeta Benni.png"],
  ],
};

const ChemistryResearchCentre = () => <ProgrammeDetail programme={programme} />;

export default ChemistryResearchCentre;
